import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/resonant-frequency-calculator',
  component: () => import('../../routes/ResonantFrequency.svelte'),
  card: {
    id: 'resonant-frequency-calculator',
    title: 'Resonant Frequency Calculator',
    description: 'Calculate the resonant frequency of an LC circuit (inductor-capacitor) from capacitance and inductance values. Shows frequency, angular frequency, reactance, and period.',
    icon: 'electric_bolt',
    iconBgClass: 'bg-blue-50',
    iconTextClass: 'text-blue-600',
    href: '/resonant-frequency-calculator',
    category: 'Physics & Science',
  },
  seo: {
    title: 'Resonant Frequency Calculator – LC Circuit Resonance',
    description: 'Free resonant frequency calculator for LC circuits. Enter capacitance (μF) and inductance (mH) to calculate resonant frequency, angular frequency, reactance, and period.',
  },
};

export default meta;